module.exports = __webpack_public_path__ + "img/fat-separator.e565370e.svg";